import { render } from "./DiscoverCom.vue?vue&type=template&id=4188d4cb"
import script from "./DiscoverCom.vue?vue&type=script&lang=js"
export * from "./DiscoverCom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__